export default __webpack_public_path__ + "a2b72dd552e37f41d4cb1f5a005edbd1.png";